const MiniSearchSkeleton = () => <div className="animate-pulse" data-sentry-component="MiniSearchSkeleton" data-sentry-source-file="MiniSearchSkeleton.jsx">
    {[...Array(5)].map((_, i) => <div key={i} className="mb-4">
        <div className="h-6 w-full rounded bg-gray-300"></div>
      </div>)}
  </div>;
export default MiniSearchSkeleton;